function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import MuiTypography from '@material-ui/core/Typography'; // NOTE: Use this table when converting from DynamicText:
//
// DynamicText-TypographyType   Typography-TypographyVariants
// ==============================================================
//   Body1                        Body2 (these have swapped.  Also, Body2 is the default style.)
//   Body2                        Body1
//   Display4                     H1
//   Display3                     H2
//   Display2                     H3
//   Display1                     H4
//   Headline                     H5
//   Title                        H6
//   SubHeading                   Subtitle1
//   Body1Bold                    Subtitle2
//
// For more info on our implementation, see the Confluence page at:
//     https://dealersocket.atlassian.net/wiki/spaces/REACT/pages/771751940/Migrating+from+DynamicText+to+Typography
//
// For more info, refer to the MUI documentation at:
//     https://material-ui.com/style/typography/#migration-to-typography-v2

export var TypographyVariants = Object.freeze({
  // MUI
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  Subtitle1: 'subtitle1',
  Subtitle2: 'subtitle2',
  Body1: 'body1',
  Body2: 'body2',
  Caption: 'caption',
  Button: 'button',
  Overline: 'overline',
  SROnly: 'srOnly',
  Inherit: 'inherit',
  // DS-UI
  Banner: 'banner',
  FormError: 'formerror',
  ToolTip: 'tooltip',
  Warning: 'warning',
  None: 'inherit'
});
var TypographyComp = React.forwardRef(function (props, ref) {
  var _classNames;

  var classes = props.classes,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      variantProp = props.variant,
      others = _objectWithoutProperties(props, ["classes", "disabled", "inline", "variant"]);

  var variant = variantProp;

  switch (variantProp) {
    case 'banner':
    case 'formerror':
    case 'tooltip':
    case 'warning':
      variant = 'inherit';
      break;

    default:
      break;
  }

  return (
    /*#__PURE__*/
    React.createElement(MuiTypography, _extends({
      ref: ref,
      classes: {
        root: classNames(classes.root, (_classNames = {}, _defineProperty(_classNames, classes[variantProp], variantProp !== 'inherit' && variant === 'inherit'), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.inline, inline), _classNames))
      },
      variant: variant
    }, others))
  );
});

var styles = function styles(theme) {
  return {
    root: {},
    banner: theme.typography.banner,
    formerror: theme.typography.formerror,
    tooltip: theme.typography.tooltip,
    warning: theme.typography.warning,
    disabled: {
      opacity: 0.5
    },
    inline: {
      display: 'inline'
    }
  };
};

export var Typography = withStyles(styles)(TypographyComp);